'use es6';

import { CREATED } from '../constants/updateTypes';
import { getUpdate } from './crmObjectLifecycleUpdateGetters';
import { getUpdateType } from './ticketUpdateMetadataGetters';
export const isTicketCreatedType = ticket => {
  const update = getUpdate(ticket);
  return getUpdateType(update) === CREATED;
};